export const ChargingStationOperatorFilter = {
    methods: {
        processChargingStationOperatorFilter(chargingStation, operators, knownOperators = []) {
            if (operators.length > 0) {
                var chargingStationOperators = [];

                if (chargingStation.cpo_id) {
                    chargingStationOperators.push(chargingStation.cpo_id);
                }

                if (knownOperators.indexOf(chargingStation.cpo_id) === -1) {
                    chargingStationOperators.push('OTHER');
                }

                for (var i = 0; i < operators.length; i++) {
                    if (chargingStationOperators.indexOf(operators[i]) > -1) {
                        return true;
                    }
                }

                return false;
            } else {
                return true;
            }
        }
    }
}
